import type {
    IconDefinition,
    SizeProp,
} from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { CustomIcon } from "@/atoms/Icon/Icon.types";
import icons, { type IconType } from "@/atoms/Icon/Icon.types";
import {
    convertLiteralSizingClassToFontSize,
    defaultIconSize,
} from "@/atoms/Icon/Icon.utils";
import type { DefaultComponentProps } from "@/types/component.types";
import cn from "@/utils/cn";
import styles from "./Icon.module.css";

interface IconProps extends DefaultComponentProps {
    readonly name: IconType;
    readonly size?: SizeProp;
}

function Icon({ className, name, size = defaultIconSize, testId }: IconProps) {
    const icon: CustomIcon | IconDefinition = icons[name];
    const classNames = cn(styles.icon, className);

    if (typeof icon === "function") {
        const IconComponent = icon;
        const fontSize = convertLiteralSizingClassToFontSize(size);
        return (
            <IconComponent
                className={classNames}
                data-testid={testId}
                height={fontSize}
                width={fontSize}
            />
        );
    }

    return (
        <FontAwesomeIcon
            className={classNames}
            data-testid={testId}
            icon={icon}
            size={size}
        />
    );
}

export default Icon;
